export enum DailyTaskType {
  EXERCISE = 'EXERCISE',
  STUDY = 'STUDY'
}
